import { Button } from "@/components/Button";
import { CookiesEnum, cookiesValues } from "@/constants/constants";
import { useUserContext } from "@/context/UserProvider";
import { useClientTranslations } from "@/hooks/useClientTranslations";
import { getClientSideCookieValue, isTvEnv } from "@/utils/common.helpers";
import { FocusKeyEnum } from "@/utils/focusKeys.helpers";
import { useFocusable } from "@noriginmedia/norigin-spatial-navigation";
import { useParams, useRouter } from "next/navigation";

export const AuthSwitch = ({ openPopup }: { openPopup: Function }) => {
  const { t, currentLanguage } = useClientTranslations();
  const router = useRouter();
  const { isLoggedIn } = useUserContext();
  const params = useParams();
  const dialect = params.dialect;

  // Check if dialect cookie exists
  const dialectCookie = getClientSideCookieValue(
    cookiesValues[CookiesEnum.Dialect],
  );
  const hasDialectCookie = !!dialectCookie;

  const { ref, focused } = useFocusable({
    focusKey: FocusKeyEnum.AUTH_SWITCH,
    onEnterPress: () => {
      if (isLoggedIn) {
        openPopup();
      } else {
        router.push(
          `/${currentLanguage}/login?redirectionAfterLoginTo=/${dialect}/settings`,
        );
      }
    },
  });

  const handleClick = () => {
    if (isLoggedIn) {
      openPopup();
    } else {
      router.push(
        `/${currentLanguage}/login?redirectionAfterLoginTo=/${dialect}/settings`,
      );
    }
  };

  const fontSizeClass = isTvEnv() ? `text-2xl` : "text-base";

  return (
    <Button
      onClick={isLoggedIn ? handleClick : undefined}
      href={
        !isLoggedIn
          ? `/${currentLanguage}/login?redirectionAfterLoginTo=${hasDialectCookie ? `/${dialect}` : "/"}`
          : undefined
      }
      variant="outlined-white"
      ref={ref}
      className={`${isTvEnv() ? "!bg-[var(--tv-settings-background)]" : ""} ${focused ? "!border-white" : "!border-white/25"} ${!focused && !isLoggedIn ? "mb-2 w-full" : ""} transition-colors ${isLoggedIn ? "hover:!bg-stg-error" : " hover:!bg-stg-primary-cta"}`}
    >
      {isLoggedIn ? (
        <p className={`${fontSizeClass} font-bold`}>
          {t("setting_page.logout")}
        </p>
      ) : (
        <p className={`${fontSizeClass} font-bold`}>{t("auth_screen.login")}</p>
      )}
    </Button>
  );
};
